import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import CycleClosingForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  attendanceGradeDataSave,
  cycleClosingAttendanceWrapperByCycleClosing,
  cycleClosingGradeDataSave,
  cycleClosingWrapperByCycleClosing,
  closeCycleMutation,
} from '../../../shared/queries/CycleClosing';
import { ACTIVE_TAB } from '../../../shared/utils/constants';
import Modal from '../../../shared/components/Modal';

const CycleClosingFormHandler = (props) => {
  const { t, history, dispatch } = props;
  const [dto, setDto] = useState();
  const [formOn, setFormOn] = useState(false);
  const [evaluationClosingWrapper, setEvaluationClosingWrapper] = useState({});
  const [attendanceWrapper, setAttendanceWrapper] = useState({});
  const [step, setStep] = useState(ACTIVE_TAB.ONE);
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const backClickHandler = () => {
    history.push('/minime/consolidacao-ciclo');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadCycleClosingWrapperByCycleClosing = (
    schoolClassId,
    subjectId,
    cycleNumber,
    courseStepId,
    courseId,
    cycleClosingId
  ) => {
    showLoading();
    const query = cycleClosingWrapperByCycleClosing(
      schoolClassId,
      subjectId,
      cycleNumber,
      courseStepId,
      courseId,
      cycleClosingId
    );

    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.cycleClosingWrapperByCycleClosing) {
          if (res.cycleClosingWrapperByCycleClosing.closingData) {
            res.cycleClosingWrapperByCycleClosing.closingData =
              res.cycleClosingWrapperByCycleClosing.closingData.map(
                (closingData) => ({
                  ...closingData,
                  average: (
                    closingData.average + closingData.classCouncil
                  ).toFixed(2),
                })
              );
          }
          setEvaluationClosingWrapper(res.cycleClosingWrapperByCycleClosing);
        } else {
          backClickHandler();
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
        }
      })
      .catch((error) => {
        hideLoading();
        if (error) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      });
  };

  const loadCycleClosingAttendanceWrapperByCycleClosing = (
    schoolClassId,
    subjectId,
    cycleNumber,
    courseStepId,
    courseId
  ) => {
    showLoading();
    const query = cycleClosingAttendanceWrapperByCycleClosing(
      schoolClassId,
      subjectId,
      cycleNumber,
      courseStepId,
      courseId
    );
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.cycleClosingAttendanceWrapperByCycleClosing) {
          if (
            res.cycleClosingAttendanceWrapperByCycleClosing.listStudentSummary
          ) {
            res.cycleClosingAttendanceWrapperByCycleClosing.listStudentSummary =
              res.cycleClosingAttendanceWrapperByCycleClosing.listStudentSummary.map(
                (sSummary) => ({
                  ...sSummary,
                  frequency:
                    sSummary.classQuantity > 0 &&
                    res.cycleClosingAttendanceWrapperByCycleClosing
                      .workDayQuantity > 0
                      ? (
                          (sSummary.classQuantity /
                            res.cycleClosingAttendanceWrapperByCycleClosing
                              .workDayQuantity) *
                          100
                        ).toFixed(2)
                      : 0,
                })
              );
          }
          setAttendanceWrapper(res.cycleClosingAttendanceWrapperByCycleClosing);
        } else {
          backClickHandler();
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
        }
      })
      .catch((error) => {
        hideLoading();
        if (error) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      });
  };

  const nextStep = (tabIndex) => {
    let updatedStep = parseInt(step, 0) + parseInt(ACTIVE_TAB.ONE, 0);
    if (tabIndex) {
      updatedStep = parseInt(tabIndex, 0);
    }
    setStep(String(updatedStep));
  };

  const turnBackStep = () => {
    const updatedStep = parseInt(step, 0) - parseInt(ACTIVE_TAB.ONE, 0);
    setStep(String(updatedStep));
    if (String(updatedStep) === ACTIVE_TAB.ONE) {
      loadCycleClosingWrapperByCycleClosing(
        dto.schoolClass.id,
        dto.subject.id,
        dto.cycleNumber,
        dto.schoolClass.courseStep.id,
        dto.schoolClass.courseStep.course.id,
        dto.id
      );
    }
    if (String(updatedStep) === ACTIVE_TAB.TWO) {
      loadCycleClosingAttendanceWrapperByCycleClosing(
        dto.schoolClass.id,
        dto.subject.id,
        dto.cycleNumber,
        dto.schoolClass.courseStep.id,
        dto.schoolClass.courseStep.course.id
      );
    }
  };

  const closingCycle = () => {
    const updatedDto = {
      ...dto,
      workDayQuantity: attendanceWrapper
        ? attendanceWrapper.workDayQuantity
        : 0,
    };
    setDto(updatedDto);
    const mutation = closeCycleMutation(updatedDto);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        history.push('/minime/consolidacao-ciclo');
        toggleModal();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const saveEvaluativeActivitiesGrid = (values) => {
    const mutation = cycleClosingGradeDataSave(values);
    showLoading();
    GraphQL(mutation, {})
      .then((res) => {
        hideLoading();
        nextStep();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        history.push(
          `/minime/consolidacao-ciclo/mnt/${res.cycleClosingSave.id}`
        );
        const updatedDto = { ...dto };
        updatedDto.id = res.cycleClosingSave.id;
        setDto(updatedDto);
        loadCycleClosingAttendanceWrapperByCycleClosing(
          values.schoolClass.id,
          values.subject.id,
          values.cycleNumber,
          values.schoolClass.courseStep.id,
          values.schoolClass.courseStep.course.id
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const savePresenceGrid = (values) => {
    const mutation = attendanceGradeDataSave(values, dto.id);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        nextStep();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const handleSubmit = (values) => {
    if (values.evaluativeActivitiesGrid && step === ACTIVE_TAB.ONE) {
      saveEvaluativeActivitiesGrid(values);
    }
    if (values.attendanceWrapper && step === ACTIVE_TAB.TWO) {
      savePresenceGrid(values);
    }
    if (step === ACTIVE_TAB.THREE) {
      toggleModal();
    }
  };

  const loadAllWrappers = (
    schoolClass,
    subject,
    cycleNumber,
    cycleClosingId
  ) => {
    loadCycleClosingWrapperByCycleClosing(
      schoolClass.id,
      subject.id,
      cycleNumber,
      schoolClass.courseStep.id,
      schoolClass.courseStep.course.id,
      cycleClosingId
    );
    loadCycleClosingAttendanceWrapperByCycleClosing(
      schoolClass.id,
      subject.id,
      cycleNumber,
      schoolClass.courseStep.id,
      schoolClass.courseStep.course.id,
      cycleClosingId
    );
  };

  useEffect(() => {
    const { location } = history;
    if (location && location.state && location.state.data) {
      const { id, schoolClass, subject, cycleNumber, cycleClosed } =
        location.state.data;
      setDto({ ...location.state.data });
      if (cycleClosed) {
        loadAllWrappers(schoolClass, subject, cycleNumber, id);
      } else {
        loadCycleClosingWrapperByCycleClosing(
          schoolClass.id,
          subject.id,
          cycleNumber,
          schoolClass.courseStep.id,
          schoolClass.courseStep.course.id,
          id
        );
      }
      setFormOn(true);
    } else {
      backClickHandler();
    }
  }, [history]);

  return (
    <SmartCard title={t('panels.cycle-consolidation')}>
      {formOn ? (
        <>
          <Modal
            color="warning"
            title={t('notifications.attention')}
            btn="Warning"
            message={t('notifications.confirming-the-closure-cycle')}
            toggle={toggleModal}
            modal={modal}
            onConfirm={() => closingCycle()}
          />

          <CycleClosingForm
            onSubmit={handleSubmit}
            backHandler={backClickHandler}
            dto={dto}
            evaluationClosingWrapper={evaluationClosingWrapper}
            attendanceWrapper={attendanceWrapper}
            dispatch={dispatch}
            step={step}
            turnBackStep={turnBackStep}
            nextStep={nextStep}
            showLoading={showLoading}
            hideLoading={hideLoading}
          />
        </>
      ) : null}
    </SmartCard>
  );
};

CycleClosingFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CycleClosingFormHandler)
);
